(ns teamoesterreich.admin-mode.data.warningMeasure
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))


(defn >warningMeasure-edit [uuid warning finished-fn]
  (ajax/auth-put> (backend/get-auth)  (str  backend/BASE_URL "/warningMeasure/" uuid)
             (ajax/serialize (merge warning
                                    {:warning-uuid uuid}))
             finished-fn))

(defn <get-warningMeasure-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/warningMeasure")
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] (let [d-warningMeasure (clojure.walk/keywordize-keys e)
                                                d-warningMeasure (assoc d-warningMeasure
                                                                   :_warningMeasure-typeName (get-in d-warningMeasure [:warningMeasure-type :warningType-name])
                                                                   :_warningMeasure-typeAbbr (get-in d-warningMeasure [:warningMeasure-type :warningType-abbr])
                                                                   )]
                                    [(:warningMeasure-uuid d-warningMeasure) d-warningMeasure]))
                                  (js->clj (json/parse r-list))))
                    )))))

(defn <get-warningMeasure [uuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/warningMeasure/" uuid)
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))
